
export const MaterialGroupCodeConstant = {
    materialGroupCode: 'api/MaterialGroupCode',  
    materialGroupCodeRoute: 'materialGroupCode',
    manageMaterialGroupCodeRoute: 'manageMaterialGroupCode',
    bulkInsertMessage:'Material group codes are successfully importd',
    searchFieldName: 'name',
    code: 'code',
};